import dayjs from "dayjs";
import { FALLBACK_DATE_FORMAT, FALLBACK_DATETIME_FORMAT, FALLBACK_TIME_FORMAT } from "~/utils/constants";

export enum DateFormatType {
  DATE,
  DATETIME,
  TIME,
}

export function getPattern(type: DateFormatType) {
  function getDateFormat() {
    if (window.SCHA.config.dateFormat) {
      return window.SCHA.config.dateFormat;
    }
    return FALLBACK_DATE_FORMAT;
  }
  function getDateTimeFormat() {
    if (window.SCHA.config.dateTimeFormat) {
      return window.SCHA.config.dateTimeFormat;
    }
    return FALLBACK_DATETIME_FORMAT;
  }
  function getTimeFormat() {
    if (window.SCHA.config.timeFormat) {
      return window.SCHA.config.timeFormat;
    }
    return FALLBACK_TIME_FORMAT;
  }
  function getJavaFormat(type: DateFormatType): string {
    switch (type) {
      case DateFormatType.DATE:
        return getDateFormat();
      case DateFormatType.DATETIME:
        return getDateTimeFormat();
      case DateFormatType.TIME:
        return getTimeFormat();
    }
  }
  function convertToDayjsFormat(format: string): string {
    return format.replaceAll("d", "D").replaceAll("y", "Y");
  }

  return convertToDayjsFormat(getJavaFormat(type));
}

function getGmt() {
  const rawOsset = window.SCHA.config.timezoneOffset;
  const offset = (rawOsset / 60).toFixed(1);
  const sign = rawOsset >= 0 ? "+" : "-";
  return `(GMT${sign}${offset})`;
}

export function formatDate(date: Date, type: DateFormatType) {
  return dayjs(date).format(getPattern(type));
}

export function formatNullableDate(
  date: Date | undefined | null,
  type: DateFormatType,
  missingDateSymbol: string = "-",
) {
  if (!date) {
    return missingDateSymbol;
  }
  return formatDate(date, type);
}
